var map = {
	"./1.png": 1391,
	"./2.png": 1392,
	"./3.png": 1393,
	"./avatar.png": 1394,
	"./crown-1.png": 1195,
	"./crown-2.png": 1196,
	"./crown-3.png": 1197,
	"./header-bg.png": 1083,
	"./like.png": 1066,
	"./logo.png": 1084,
	"./no-ranking.png": 1198,
	"./prize-bg.png": 1395,
	"./prize-top-bg.png": 1396,
	"./ranking-bg-1.png": 1397,
	"./ranking-bg-2.png": 1398,
	"./ranking-bg-3.png": 1399,
	"./start.png": 1085,
	"./top-up-bottom.png": 1400,
	"./top-up-popup.png": 1401,
	"./top-up.png": 1402,
	"./unlike.png": 1199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2186;